import React from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowLeft } from "lucide-react";
import PublicShell from "@/components/PublicShell";
import { useI18n } from "@/lib/I18nContext";

export default function ForgotPassword() {
  const { t } = useI18n();
  const adminEmail = "gd.toro@hotmail.com";

  return (
    <PublicShell>
      <div className="max-w-xl mx-auto px-6 py-12" data-testid="forgot-password-page">
        <Link
          to="/login"
          data-testid="back-to-login"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-zinc-400 hover:text-[var(--c-lime)] mb-6"
        >
          <ArrowLeft size={14} /> {t("forgot.back")}
        </Link>

        <div className="text-[11px] uppercase tracking-widest text-zinc-500 font-mono-data mb-2">
          {t("forgot.kicker")}
        </div>
        <h1 className="font-display text-4xl md:text-5xl uppercase leading-none mb-4">
          {t("forgot.title")}
        </h1>
        <p className="text-zinc-300 text-base md:text-lg leading-relaxed mb-6">
          {t("forgot.subtitle")}
        </p>

        <div className="bg-zinc-900 border border-zinc-800 p-6 space-y-4" data-testid="forgot-contact-box">
          <div className="flex items-start gap-3">
            <Mail className="text-[var(--c-lime)] mt-1 shrink-0" size={20} />
            <div>
              <div className="text-[11px] uppercase tracking-widest text-zinc-500 font-mono-data mb-1">
                {t("forgot.contactLabel")}
              </div>
              <a
                href={`mailto:${adminEmail}?subject=${encodeURIComponent(t("forgot.mailSubject"))}`}
                data-testid="forgot-admin-email-link"
                className="text-[var(--c-lime)] hover:underline text-base md:text-lg break-all"
              >
                {adminEmail}
              </a>
            </div>
          </div>
          <div className="text-sm text-zinc-400 leading-relaxed border-t border-zinc-800 pt-4">
            {t("forgot.help")}
          </div>
        </div>

        <div className="mt-8 text-sm text-zinc-400 text-center">
          {t("forgot.rememberCta")}{" "}
          <Link to="/login" data-testid="link-to-login" className="text-[var(--c-lime)] underline underline-offset-2">
            {t("login.cta")}
          </Link>
        </div>
      </div>
    </PublicShell>
  );
}
